import { formDefinitions } from "../Forms/paths";

export function templateFilterReducer(state, action) { 
    let newState = Object.assign({}, state);

    const { type = "", payload = {} } = action;
    const {formType, id, values } = payload;
    if (type === "UPDATE" && formType && id) {
        if(!newState?.[formType]) {
            newState[formType] = {};
        }
        newState[formType][id] = values;
    }

    if ( type === "RESET") {
        return {};
    }

    return newState;
}


export function getAdditionalFiltersInput(formType) {
    let formObj = {}
    Object.keys(formDefinitions).forEach(pathId => {
    if(formDefinitions[pathId].formType === formType) {
        formObj = formDefinitions[pathId];
    }
    })
    const additionalFilters = formObj?.additionalFilters ?? [];
    return additionalFilters;
}

export function transformTermCode(termCode){
    let result = "-"
    if(termCode){
        const termCodeStr = termCode.toString().padStart(4, '0');
        //don't remove fullMatch, although it's not used we are beaking down the match array - jmm
        const [fullMatch, centuryCountSince1900, twoDigitYear, seasonCondition] = termCodeStr.match(/^(\d)(\d{2})(\d)$/);
        const century = 19 + parseInt(centuryCountSince1900)
        const year = century.toString() + twoDigitYear
        let academicSeason;
        switch (seasonCondition) {
            case "2":
                academicSeason = "Spring "
                break;
            case "4":
                academicSeason = "Summer "
                break;
            case "8":
                academicSeason = "Autumn "
                break;
        
            default:
                throw new Error(`Academic Season Condition of ${seasonCondition} not handled`);
        }
        result = academicSeason + year;
    }
    return result;
}

export function extractValueOfFormDetailFieldObjectType(fieldName, formDetailFields){
    if (!formDetailFields || !Array.isArray(formDetailFields)) {
        return null;
    }
    
    const foundField = formDetailFields.find(field => field.field === fieldName);
    return foundField ? foundField.value : null;
}